import { Divider, LinkText } from "flicket-ui";
import { SinglePageCheckoutListItem } from "../ListItem";

const mockPromoCode = {
  code: "TESTCODE",
  discount: 10,
  discountedPrice: -90,
  type: "percentage", // or "fixed"
};

export const SinglePageCheckoutOrderSummaryPromoCodeSummary = () => {
  const discountSuffix = mockPromoCode.type === "percentage" ? "%" : "$";

  const removePromoCode = () => {
    console.log("removed");
  };

  return (
    <>
      <Divider />
      <SinglePageCheckoutListItem
        title={`Promo code: ${mockPromoCode.code}`}
        subtitle={
          <>
            {mockPromoCode.discount}
            {discountSuffix} discount applied.{" "}
            <LinkText onClick={removePromoCode}>Remove</LinkText>
          </>
        }
        price={mockPromoCode.discountedPrice}
      />
    </>
  );
};
